import Button from "../Button";
import { m } from "../paraglide/messages";
import BaseModal from "./BaseModal";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  isSaving: boolean;
  isSaveDisabled?: boolean;
  onStay: () => void;
  onDiscardAndLeave: () => void;
  onSaveAndLeave: () => void;
}

export default function UnsavedChangesModal({
  isOpen,
  isSaving,
  isSaveDisabled = false,
  onStay,
  onDiscardAndLeave,
  onSaveAndLeave,
}: Readonly<UnsavedChangesModalProps>) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onStay}
      onOpenChange={(isOpen) => {
        if (!isOpen) onStay();
      }}
      title={m.unsaved_changes_modal_title()}
      description={m.unsaved_changes_modal_description()}
      size="xl"
      fit="narrow"
      isDismissable={!isSaving}
      isKeyboardDismissDisabled={isSaving}
      footer={
        <div className="flex w-full items-center justify-end gap-3">
          <Button
            size="md"
            variant="ghost"
            color="secondary"
            onPress={onDiscardAndLeave}
            isDisabled={isSaving}
          >
            {m.unsaved_changes_discard_and_leave()}
          </Button>
          <Button
            size="md"
            variant="ghost-light-bordered"
            color="secondary"
            onPress={onStay}
            isDisabled={isSaving}
          >
            {m.unsaved_changes_stay_on_page()}
          </Button>
          <Button
            size="md"
            color="primary"
            onPress={onSaveAndLeave}
            isLoading={isSaving}
            isDisabled={isSaveDisabled}
          >
            {m.unsaved_changes_save_and_leave()}
          </Button>
        </div>
      }
    />
  );
}
